export default {

    drawerBody: {
        display: "flex",
        flexDirection: "column",
        rowGap: "50px"
    },

    lableText: {
        fontSize: "20px",
    },

    recipientOptionContaienr: {
        display: "flex",
        margin: "10px 0 35px",
        columnGap: "25px"
    },

}